import React from "react";
import "./AuthenticationFormHeader.scoped.scss";

const AuthenticationFormHeader = ({ title, baseId }) => {
    return (
        <div className="logged_title">
            <h2 id={baseId ? `${baseId}-title` : null}>{title}</h2>
        </div>
    );
}

export default AuthenticationFormHeader;